import { ChangeDetectionStrategy, Component, computed, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';

const TUR_SECENEKLERI = ['Alüminyum', 'Çelik', 'Paslanmaz Çelik', 'Pirinç', 'Bakır', 'Plastik', 'Ahşap', 'Kompozit', 'Cam', 'Diğer'];

@Component({
  selector: 'cam-malzeme-tanimi-edit',
  standalone: true,
  imports: [FormsModule, NzInputModule, NzInputNumberModule, NzSelectModule,
    CdkTextareaAutosize],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="se">
      <div class="se-baslik">
        <div class="se-baslik-ikon" style="background:linear-gradient(135deg,#0e7490,#06b6d4)">🧊</div>
        <span>Malzeme Tanımı</span>
      </div>
      <div class="se-form">
        <div class="form-grup">
          <label>Malzeme Adı <span class="zorunlu">*</span></label>
          <div class="input-wrap">
            <input nz-input autocomplete="off"
              [ngModel]="p()?.malzemeAdi || ''" (ngModelChange)="guncelle('malzemeAdi', $event)"
              placeholder="Malzeme adı..."/>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="form-satir">
          <div class="form-grup" style="flex:1">
            <label>Tür</label>
            <div class="input-wrap">
              <nz-select [ngModel]="p()?.pilesmi" (ngModelChange)="guncelle('pilesmi', $event)"
                nzPlaceHolder="Tür seçin..." nzAllowClear style="width:100%">
                @for (t of turler; track t) { <nz-option [nzValue]="t" [nzLabel]="t"></nz-option> }
              </nz-select>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup" style="flex:0 0 120px">
            <label>Kalınlık (mm)</label>
            <div class="input-wrap">
              <nz-input-number [ngModel]="p()?.kalinlik || null" (ngModelChange)="guncelle('kalinlik', $event)"
                [nzMin]="0" [nzStep]="0.5" style="width:100%"></nz-input-number>
              <div class="input-glow"></div>
            </div>
          </div>
        </div>

        <div class="form-satir">
          <div class="form-grup" style="flex:1">
            <label>Renk</label>
            <div class="input-wrap">
              <input nz-input autocomplete="off"
                [ngModel]="p()?.renk || ''" (ngModelChange)="guncelle('renk', $event)" placeholder="Şeffaf, Bronz..."/>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup" style="flex:0 0 140px">
            <label>Birim Fiyat (m²)</label>
            <div class="input-wrap">
              <nz-input-number [ngModel]="p()?.birimFiyat || null" (ngModelChange)="guncelle('birimFiyat', $event)"
                [nzMin]="0" [nzStep]="1" style="width:100%"></nz-input-number>
              <div class="input-glow"></div>
            </div>
          </div>
        </div>

        <div class="se-ayirici"></div>

        <div class="form-satir">
          <div class="form-grup" style="flex:0 0 120px">
            <label>Stok Miktarı</label>
            <div class="input-wrap">
              <nz-input-number [ngModel]="p()?.stokMiktari || null" (ngModelChange)="guncelle('stokMiktari', $event)"
                [nzMin]="0" [nzStep]="1" style="width:100%"></nz-input-number>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup" style="flex:0 0 120px">
            <label>Min. Stok</label>
            <div class="input-wrap">
              <nz-input-number [ngModel]="p()?.minimumStok || null" (ngModelChange)="guncelle('minimumStok', $event)"
                [nzMin]="0" [nzStep]="1" nzPlaceHolder="Uyarı sınırı" style="width:100%"></nz-input-number>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup" style="flex:1">
            <label>Tedarikçi</label>
            <div class="input-wrap">
              <input nz-input autocomplete="off"
                [ngModel]="p()?.tedarikci || ''" (ngModelChange)="guncelle('tedarikci', $event)" placeholder="Tedarikçi..."/>
              <div class="input-glow"></div>
            </div>
          </div>
        </div>
        @if (stokDurum()) {
          <div class="stok-uyari" [class.stok-uyari--tehlike]="stokDurum() === 'tehlike'" [class.stok-uyari--uyari]="stokDurum() === 'uyari'">
            {{ stokDurum() === 'tehlike' ? '⛔ STOK KRİTİK — Tedarik Gerekli!' : '⚠️ Stok azalıyor' }}
          </div>
        }

        <div class="se-ayirici"></div>

        <div class="form-grup">
          <label>Notlar</label>
          <div class="input-wrap">
            <textarea nz-input autocomplete="off"
              [ngModel]="p()?.notlar || ''" (ngModelChange)="guncelle('notlar', $event)"
              placeholder="Notlar..." cdkTextareaAutosize [cdkAutosizeMinRows]="2" [cdkAutosizeMaxRows]="4"></textarea>
            <div class="input-glow"></div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrl: './cam-edit.styles.less',
})
export class CamMalzemeTanimiEditComponent extends FikoYTKokBilesenComponent {
  parametreler = model<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  turler = TUR_SECENEKLERI;
  stokDurum = computed(() => {
    const stok = +(this.p()?.stokMiktari || 0);
    const min = +(this.p()?.minimumStok || 0);
    if (!min || !stok) return null;
    if (stok <= min * 0.5) return 'tehlike';
    if (stok <= min) return 'uyari';
    return null;
  });
  guncelle(alan: string, deger: any) {
    const params = this.parametreler();
    if (params?.ek) { params.ek[alan] = deger; this.parametreler.set({ ...params }); }
  }
}
